import { ARTISTS } from "../../data/content";

export const Marquee = () => {
  const items = [...ARTISTS, ...ARTISTS];
  return (
    <section data-testid="marquee-section" className="relative py-16 lg:py-24 bg-ink border-y border-gold/15 overflow-hidden">
      <div className="max-w-[88rem] mx-auto px-5 sm:px-8 mb-8">
        <span className="text-[11px] uppercase tracking-[0.35em] text-white/40">
          Shared the stage with the legends
        </span>
      </div>
      <div className="relative flex overflow-hidden">
        <div className="flex shrink-0 animate-marquee whitespace-nowrap will-change-transform">
          {items.map((a, i) => (
            <span key={i} className="flex items-center">
              <span className="font-serif italic text-3xl sm:text-5xl lg:text-6xl text-white/80 px-8">
                {a}
              </span>
              <span className="text-gold text-2xl lg:text-4xl">✦</span>
            </span>
          ))}
        </div>
      </div>
      {/* edge fades */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-ink to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-ink to-transparent" />
    </section>
  );
};
